// extracted by mini-css-extract-plugin
export default {"text":"Label_text__C4HRS","link":"Label_link__-FSGd"};